import React, { useState, useContext, useEffect, useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Link from "@material-ui/core/Link";
import Alert from "@material-ui/lab/Alert";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import ColorModeContext from "../../layout/themeContext";
import useSettings from "../../hooks/useSettings";

import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import { Helmet } from "react-helmet";
import {
  TextField,
  InputAdornment,
  IconButton,
  makeStyles,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

// Removido: wallpaper global aplicando background no body (causava piscar)
import Collapse from "@material-ui/core/Collapse";

import {
  Email,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => {
  const main = theme.palette.primary.main;
  const dark = theme.palette.primary.dark;
  return {
    '@global': {
      'body': {
        // Attempt to ensure the body is scrollable on desktop
        // This might be necessary if other global styles are interfering.
        minHeight: '100vh', // Body should be at least as tall as the viewport
        overflowY: 'auto !important', // Force scrollbars if content overflows
        // Hide scrollbar for Webkit browsers (Chrome, Safari, Edge)
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        // Hide scrollbar for Firefox
        scrollbarWidth: 'none',
        // Hide scrollbar for IE and Edge (older versions)
        '-ms-overflow-style': 'none',
      },
    },    root: {
      minHeight: "100vh",
      width: "100%", // Ensures full width
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start", // Aligns content to the top, critical for page scroll
      // Background será aplicado dinamicamente via style prop
      padding: 'clamp(16px, 4vw, 48px) 0', // Dynamic padding
      position: "relative",
      boxSizing: 'border-box',
      // No overflowY on root for desktop: this allows the page (body) to scroll.
      [theme.breakpoints.down('sm')]: { // For small screens (mobile)
        // On mobile, the root container itself becomes scrollable,
        // overriding the body scroll behavior for a better mobile experience.
        overflowY: 'auto',
        // Hide scrollbar for Webkit browsers (Chrome, Safari, Edge)
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        // Hide scrollbar for Firefox
        scrollbarWidth: 'none',
        // Hide scrollbar for IE and Edge (older versions)
        '-ms-overflow-style': 'none',
      },
    },
    card: {
      backgroundColor: theme.mode === "light" ? "rgba(255,255,255,0.97)" : "rgba(20,20,20,0.97)",
      borderRadius: 22,
      boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.15)",
      padding: 0,
      minWidth: 320,
      maxWidth: 520,
      width: "100%",
      marginTop: 'clamp(16px, 6vh, 48px)',
      marginBottom: 'clamp(16px, 6vh, 48px)',
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      transition: 'box-shadow 0.3s, transform 0.3s',
      [theme.breakpoints.down('xs')]: {
        minWidth: 0,
        maxWidth: '99vw',
        borderRadius: 0,
        marginTop: 0,
        marginBottom: 0,
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 0,
        maxWidth: '99vw',
        borderRadius: 10,
        marginTop: 0,
        marginBottom: 0,
      },
    },
    cardHeader: {
      textAlign: "center",
      padding: "38px 38px 0 38px",
      background: theme.mode === "light" ? "rgba(255,255,255,0.85)" : "rgba(30,30,30,0.85)",
    },
    logoImg: {
      width: "100%",
      maxWidth: "100px",
      height: "auto",
      maxHeight: "100px",
      margin: "0 auto",
      content:
        "url(" +
        (theme.mode === "light"
          ? theme.calculatedLogoLight()
          : theme.calculatedLogoDark()) +
        ")",
    },

    title: {
      fontWeight: 700,
      fontSize: 30,
      color: theme.palette.text.primary,
      marginBottom: 6,
      marginTop: 0,
    },
    subtitle: {
      fontSize: 16,
      color: theme.palette.text.secondary,
      marginBottom: 18,
      marginTop: 0,
    },
    cardContent: {
      padding: 28,
      display: "flex",
      flexDirection: "column",
      gap: 18,
      background: "none",
    },
    form: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 18,
    },
    submit: {
      marginTop: 18,
      borderRadius: 10,
      fontWeight: 700,
      fontSize: 18,
      width: "100%",
      background: main,
      color: "#fff",
      padding: "14px 0",
      boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)",
      transition: "all 0.2s",
      '&:hover': {
        background: dark,
        transform: "scale(1.01)",
      },
    },
    cardFooter: {
      background: theme.mode === "light" ? "rgba(255,255,255,0.85)" : "rgba(30,30,30,0.85)",
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: 18,
      textAlign: "center",
    },
    recoveryLink: {
      color: main,
      textDecoration: "underline",
      fontWeight: 500,
      cursor: "pointer",
      '&:hover': { color: dark },
    },
    bottomLink: {
      marginTop: 28,
      textAlign: "center",
      color: "#fff",
      fontSize: 16,
      textShadow: "0 1px 4px rgba(0,0,0,0.10)",
      width: 440,
      maxWidth: "95vw",
      marginLeft: "auto",
      marginRight: "auto",
      position: "static",
      left: "unset",
      top: "unset",
      transform: "none",
    },
    input: {
      background: theme.mode === "light" ? "rgba(255,255,255,0.7)" : "rgba(40,40,40,0.7)",
      borderRadius: 8,
    },
    label: {
      color: theme.palette.text.primary,
      fontWeight: 600,
      marginBottom: 4,
      fontSize: 15,
    },
    rememberMe: {
      marginTop: -8,
      marginBottom: -8,
      '& .MuiFormControlLabel-label': {
        color: theme.mode === 'dark' ? '#fff' : theme.palette.text.primary,
      },
    },
    link: {
      fontSize: 16,
      color: "#fff",
      textDecoration: "underline",
      cursor: "pointer",
      fontWeight: 600,
      transition: "color 0.2s",
      '&:hover': {
        color: main,
      },
    },
  };
});

const Login = () => {
  const colorMode = useContext(ColorModeContext);
  const classes = useStyles({ colorMode });
  const { appLogoFavicon, appName, mode, calculatedLogoLight, calculatedLogoDark } = colorMode;

  // console.debug("appName atual:", appName);
  // Estados do componente
  const [user, setUser] = useState({ email: "", password: "" });
  const [allowSignup, setAllowSignup] = useState(false);
  const [displayAppName, setDisplayAppName] = useState("Plataforma");
  const { getPublicSetting } = useSettings();
  const { handleLogin, loading } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [formErrors, setFormErrors] = useState({ email: "", password: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formAlert, setFormAlert] = useState({ type: null, message: "" });
  // Estados para personalização do background
  const [loginBackgroundType, setLoginBackgroundType] = useState("gradient");
  const [loginBackgroundColor, setLoginBackgroundColor] = useState("#065183");
  const [loginBackgroundImage, setLoginBackgroundImage] = useState("");
  const [gradientColor1, setGradientColor1] = useState("#065183");
  const [gradientColor2, setGradientColor2] = useState("#39ACE7");

  // -- Utilitário: injeta metas e atualiza manifest dinamicamente com o appName (sem hardcode)
  function ensureBranding(appNameValue) {
    try {
      const name = (appNameValue || "").trim();
      if (!name) return;

      // Atualiza metas de app name para iOS e navegadores em geral
      const setMeta = (n, v) => {
        let el = document.querySelector(`meta[name="${n}"]`);
        if (!el) {
          el = document.createElement("meta");
          el.setAttribute("name", n);
          document.head.appendChild(el);
        }
        el.setAttribute("content", v);
      };
      setMeta("application-name", name);
      setMeta("apple-mobile-web-app-title", name);

      // Atualiza manifest em runtime (Android usa name/short_name do manifest)
      const link = document.querySelector('link[rel="manifest"]');
      if (link && link.href) {
        fetch(link.href)
          .then(r => r.json())
          .then(man => {
            try {
              const patched = { ...man, name, short_name: name };
              const blob = new Blob([JSON.stringify(patched)], { type: 'application/json' });
              const url = URL.createObjectURL(blob);
              link.href = url;
            } catch (_) {}
          })
          .catch(() => {});
      }
    } catch (_) {}
  }

  // Memoiza o cálculo do logo para evitar recálculos desnecessários
  const logoSrc = useMemo(() => {
    let src = "/logo.png";
    try {
      let candidate = null;
      if (mode === "light" && typeof calculatedLogoLight === "function") {
        candidate = calculatedLogoLight();
      } else if (mode === "dark" && typeof calculatedLogoDark === "function") {
        candidate = calculatedLogoDark();
      }
      if (typeof candidate === "string" && candidate.trim() && candidate !== "undefined" && candidate !== "null") {
        src = candidate;
      }
    } catch (e) { 
      console.warn("Erro ao calcular logo:", e);
    }
    return src;
  }, [mode, calculatedLogoLight, calculatedLogoDark]);
  // Calcula o background dinâmico baseado nas configurações
  const getDynamicBackgroundStyle = useMemo(() => {
    const main = colorMode.primaryColorLight || "#065183";
    const dark = colorMode.primaryColorDark || "#39ACE7";
    
    if (loginBackgroundType === "image" && loginBackgroundImage) {
      return {
        backgroundImage: `url(${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080'}/public/${loginBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      };
    } else if (loginBackgroundType === "color") {
      return {
        background: loginBackgroundColor
      };
    } else {
      // gradient - usando cores personalizadas ou fallback para cores primárias
      const color1 = gradientColor1 || main;
      const color2 = gradientColor2 || dark;
      return {
        background: `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`
      };
    }
  }, [loginBackgroundType, loginBackgroundColor, loginBackgroundImage, gradientColor1, gradientColor2, colorMode.primaryColorLight, colorMode.primaryColorDark]);

  // Função de validação de email
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Função de validação do formulário
  const validateForm = () => {
    const errors = { email: "", password: "" };
    let isValid = true;

    if (!user.email.trim()) {
      errors.email = "E-mail é obrigatório";
      isValid = false;
    } else if (!validateEmail(user.email)) {
      errors.email = "E-mail inválido";
      isValid = false;
    }

    if (!user.password.trim()) {
      errors.password = "Senha é obrigatória";
      isValid = false;
    } else if (user.password.length < 6) {
      errors.password = "Senha deve ter pelo menos 6 caracteres";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
    
    // Limpa erros quando o usuário começa a digitar
    if (formErrors[name]) {
      setFormErrors({ ...formErrors, [name]: "" });
    }

    // Gerencia o localStorage apenas para email (não senha por segurança)
    if (name === "email" && rememberMe) {
      localStorage.setItem("rememberedEmail", value);
    }
  };
  useEffect(() => {
    // Carrega apenas o email salvo (por segurança, não salvamos senha)
    const savedEmail = localStorage.getItem("rememberedEmail");

    if (savedEmail) {
      setUser(prev => ({
        ...prev,
        email: savedEmail,
      }));
      setRememberMe(true);
    }
  }, []);

  const handleChangeCheck = (checked) => {
    setRememberMe(checked);
    if (checked && user.email) {
      localStorage.setItem("rememberedEmail", user.email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
  };

  const handlSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setFormAlert({ type: null, message: "" });
    setIsSubmitting(true);
    try {
      await handleLogin(user);
      // Se chegou aqui, o login foi bem-sucedido
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", user.email);
      }
    } catch (err) {
      // Tratamento inline: credenciais inválidas (401) ou plano vencido (402)
      const status = err?.status;
      const code = (err?.code || "").toString();

      if (status === 401 || code === "ERR_INVALID_CREDENTIALS") {
        setFormErrors(prev => ({
          ...prev,
          email: prev.email || "E-mail ou senha inválidos.",
          password: prev.password || "Verifique seus dados e tente novamente.",
        }));
        setFormAlert({ type: "error", message: "Não foi possível autenticar. Verifique e tente novamente." });
      } else if (status === 402 || code === "ERR_SUBSCRIPTION_EXPIRED") {
        setFormAlert({
          type: "warning",
          message: "Acesso bloqueado. Entre em contato com o gerente da sua conta para mais informações.",
        });
      } else {
        // Erro genérico
        setFormAlert({ type: "error", message: "Ocorreu um erro ao tentar entrar. Tente novamente." });
      }
      console.error("Erro no login:", err);
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    // Carrega configurações públicas
    const loadPublicSettings = async () => {
      try {
        // Carrega allowSignup
        const signupSetting = await getPublicSetting("allowSignup");
        setAllowSignup(signupSetting === "enabled");
        
        // Carrega appName
        const appNameSetting = await getPublicSetting("appName");
        if (appNameSetting && appNameSetting.trim() && appNameSetting !== "Plataforma WhatsApp") {
          setDisplayAppName(appNameSetting);
          try { localStorage.setItem('public:appName', appNameSetting); } catch (_) {}
        }
        
        //console.log("Configurações carregadas - appName:", appNameSetting);
      } catch (error) {
        //console.error("Erro ao carregar configurações públicas:", error);
      }
    };

    loadPublicSettings();
  }, [getPublicSetting]);  useEffect(() => {
    // Carrega configurações de background
    const loadBackgroundSettings = async () => {
      try {
        const backgroundType = await getPublicSetting("loginBackgroundType");
        const backgroundColor = await getPublicSetting("loginBackgroundColor");
        const backgroundImage = await getPublicSetting("loginBackgroundImage");
        const gradientColor1Setting = await getPublicSetting("loginGradientColor1");
        const gradientColor2Setting = await getPublicSetting("loginGradientColor2");
        
        setLoginBackgroundType(backgroundType || "gradient");
        setLoginBackgroundColor(backgroundColor || "#065183");
        setLoginBackgroundImage(backgroundImage || "");
        setGradientColor1(gradientColor1Setting || "#065183");
        setGradientColor2(gradientColor2Setting || "#39ACE7");
      } catch (error) {
        console.error("Erro ao carregar configurações de background:", error);
      }
    };

    loadBackgroundSettings();
  }, [getPublicSetting]);

  // Quando appName público for carregado em displayAppName, injeta branding
  useEffect(() => {
    try { ensureBranding(displayAppName); } catch (_) {}
  }, [displayAppName]);
  if (loading) {
    return <div style={{ color: "#fff", fontSize: "18px" }}>Carregando...</div>;
  }

  return (
    <>
      <Helmet>
        <title>{displayAppName}</title>

        <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"} />
      </Helmet>
      <div className={classes.root} style={getDynamicBackgroundStyle}>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <img
              className={classes.logoImg}
              alt="logo"
              src={logoSrc}
            />            <div className={classes.title}>
              Bem-vindo ao<br />{displayAppName}
            </div>
            <div className={classes.subtitle}>Sua plataforma de atendimento multi-WhatsApp</div>
          </div>
          <div className={classes.cardContent}>
            {/* Mensagens inline: animação de abrir/fechar com Collapse, sem ocupar espaço quando oculto */}
            <Collapse in={!!formAlert.type} timeout={250} mountOnEnter unmountOnExit>
              <Alert severity={formAlert.type || "error"} style={{ marginBottom: 16 }}>
                {formAlert.message}
              </Alert>
            </Collapse>
            
            <form className={classes.form} noValidate onSubmit={handlSubmit}>
              <div>
                <div className={classes.label}>{i18n.t("login.form.email")}</div>
                <TextField
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  id="email"
                  name="email"
                  placeholder="Insira seu email."
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                  InputProps={{
                    className: classes.input,
                    endAdornment: (
                      <InputAdornment position="end" style={{ paddingInline: 10 }}>
                        <Email color="inherit" />
                      </InputAdornment>
                    ),
                  }}
                  value={user.email}
                  onChange={handleChangeInput}
                  autoComplete="email"
                  autoFocus
                />
              </div>
              <div>
                <div className={classes.label}>{i18n.t("login.form.password")}</div>
                <TextField
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  name="password"
                  id="password"
                  placeholder="••••••••"
                  error={!!formErrors.password}
                  helperText={formErrors.password}
                  value={user.password}
                  onChange={handleChangeInput}
                  autoComplete="current-password"
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    className: classes.input,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((e) => !e)}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <FormControlLabel
                className={classes.rememberMe}
                control={
                  <Checkbox
                    color="primary"
                    id="check"
                    checked={rememberMe}
                    onChange={(e) => handleChangeCheck(e.target.checked)}
                  />
                }
                label="Lembrar e-mail"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "ENTRANDO..." : "ENTRAR"}
              </Button>
            </form>
          </div>
          <div className={classes.cardFooter}>
            <span style={{ fontSize: 15, color: "#666" }}>
              Esqueceu sua senha?{' '}
              <Link component={RouterLink} to="/recovery-password" className={classes.recoveryLink}>
                Recuperar senha.
              </Link>
            </span>
          </div>
        </div>
        
        {/* Só exibe o link de cadastro se estiver habilitado */}
        {allowSignup && (
          <div className={classes.bottomLink}>
            <span>Não tem uma conta?{' '}
              <Link component={RouterLink} to="/signup" className={classes.link}>
                Crie uma agora
              </Link>
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default Login;